import actions from './actions'
import { MaintenanceState } from './types'

const initialState: MaintenanceState = {
  screen: { kind: 'none' },
}

interface MaintenanceAction {
  type: string
  payload?: Partial<MaintenanceState>
}

export default function maintenanceReducer(
  state: MaintenanceState = initialState,
  action: MaintenanceAction,
): MaintenanceState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
